export const environment = {
  production: true,
  timeoffset: (new Date().getTimezoneOffset() / -60) * 60 * 60 * 1000, // UTC+7
  // apiUrl: 'http://localhost:5000/components',
  apiUrl: 'https://aqb-api.ezc.me/components',
  roles: [
    'manager', // Quản lý
    'manufacture', // Sản xuất
    'warehouse', // Kho
    'accountant', // Kế toán
    'admin', // Quản trị viên
    'superadmin', // Quản trị viên cấp cao
    'supervisor', // Giám sát
    'hr', // Nhân sự
    'sales', // Bán hàng
    'marketing', // Tiếp thị
    'support', // Hỗ trợ
    'developer', // Phát triển
    'designer', // Thiết kế
    'analyst', // Phân tích
    'consultant', // Tư vấn
    'auditor', // Kiểm toán
    'intern', // Thực tập sinh

  ],
  pageSize: [25, 50, 100, 200, 500],
  callRecordType: [
    { name: 'in', value: 1 },
    { name: 'out', value: 2 },
    { name: 'missed', value: 3 },
    { name: 'voicemail', value: 4 },

  ],
  timesheetDays: [
    { name: 'monday', day: 2, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'tuesday', day: 3, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'wednesday', day: 4, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'thursday', day: 5, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'friday', day: 6, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'saturday', day: 7, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 },
    { name: 'sunday', day: 8, isDayOff: false, start: '09:00', end: '18:00', delay: 5, requiredHours: 9.5 }
  ]
  // Replace with your call record types
  // Replace with your roles
  // unit: [
  //   { "name": "kg", "value": 0 },
  //   { "name": "g", "value": 1 },
  //   { "name": "l", "value": 2 },
  //   { "name": "ml", "value": 3 },
  //   { "name": "m3", "value": 4 },
  //   { "name": "cm3", "value": 5 },
  //   { "name": "m2", "value": 6 },
  //   { "name": "cm2", "value": 7 }
  // ], // Replace with your units
};
